export const orderType = [
    "Self",
    "Job-Work",
]